import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useScrollReveal } from './useScrollReveal';
const pains = ['Cancelaste planes por el dolor sin poder explicar bien por qué.', 'Tomaste 3 ibuprofeno 600 juntos rezando que hicieran efecto.', "Te dijeron 'es normal que duela un poco' y lo creíste por años.", 'Lloraste sola en el baño esperando que pasara.', 'Trabajás, estudiás o maternás con un dolor que nadie más ve.'];
export function PainSection() {
  const ref = useScrollReveal();
  return <section className="w-full bg-white py-16 px-5 flex justify-center" data-id="element-88">
      <div ref={ref} className="fade-up w-full max-w-md flex flex-col gap-8" data-id="element-89">
        <h2 className="font-serif font-bold text-petroleo text-3xl leading-tight" data-id="element-90">
          ¿Te suena familiar alguna de estas situaciones?
        </h2>
        <ul className="flex flex-col gap-4" data-id="element-91">
          {pains.map((pain, index) => <li key={index} className="flex items-start gap-3" data-id="element-92">
              <div className="mt-1 flex-shrink-0 bg-blush-light p-1 rounded-full" data-id="element-93">
                <ArrowRight className="w-4 h-4 text-petroleo" data-id="element-94" />
              </div>
              <p className="text-gray-700 text-base leading-snug" data-id="element-95">{pain}</p>
            </li>)}
        </ul>
        <div className="bg-salvia-light border-l-4 border-salvia p-4 rounded-r-xl mt-2" data-id="element-96">
          <p className="font-serif font-bold text-petroleo text-lg" data-id="element-97">
            "Eso no es normal. Y vos no estás exagerando."
          </p>
        </div>
      </div>
    </section>;
}